import { useParams } from "react-router-dom";
import SiteHeaderV2 from "@/components/v2/SiteHeaderV2";
import ComingSoon from "@/components/v2/ComingSoon";
import { getCommunityModule } from "@/data/v2Config";

export default function CommunityFeaturePage() {
  const { key } = useParams();
  const mod = getCommunityModule(key);

  return (
    <div className="min-h-screen bg-slate-50">
      <SiteHeaderV2 />
      {mod ? (
        <ComingSoon
          icon={mod.icon}
          eyebrow="RouteHaul Community · Coming soon"
          title={mod.label}
          description={mod.desc}
          note="We're building this into your learning experience. For now, keep working through your missions — everything you need to start is already there."
          backTo="/v2"
          backLabel="Back to dashboard"
          testid="community-feature-coming-soon"
        />
      ) : (
        <ComingSoon
          title="Not found"
          description="We couldn't find that section."
          backTo="/v2"
          backLabel="Back to dashboard"
        />
      )}
    </div>
  );
}
